import { createAsyncThunk } from '@reduxjs/toolkit';
import { setReportData, setLoading, setSearchResults, setLoadingSearch } from './expenseBalanceSlice';
import { getIndirectExpenseBalanceApi } from '../../../apiservice/dashboard';
import { getAccountBySeachApi } from '../../../apiservice/setting';

export const fetchExpenseBalance = createAsyncThunk(
    'expenseBalance/fetchExpenseBalance',
    async (payload, { dispatch, getState }) => {
        try {
            dispatch(setLoading(true));

            const requestPayload = {
                accId: payload.selectedAccount ? payload.selectedAccount.acc_id : null,
            };

            if (payload.selectedType.type === "Date Wise") {
                requestPayload.fromDate = payload.fromDate;
                requestPayload.toDate = payload.toDate;
            }

            const response = await getIndirectExpenseBalanceApi(requestPayload);

            if (response.data) {
                // Filter out accounts with zero balance
                const filteredExpenses = response.data.expenses.filter(exp => exp.balance != 0);
                dispatch(setReportData({
                    expenses: filteredExpenses,
                    total_balance: response.data.total_balance
                }));
            }

            return response.data;
        } catch (error) {
            console.error('Error fetching expense balance:', error);
            throw error;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const searchAccounts = createAsyncThunk(
    'expenseBalance/searchAccounts',
    async (searchTerm, { dispatch, getState }) => {
        try {
            dispatch(setLoadingSearch(true));

            const response = await getAccountBySeachApi({
                query: searchTerm.trim(),
                multiType: ["indirect_expense"],
            });

            dispatch(setSearchResults(response.data || []));
            return response.data;
        } catch (error) {
            console.error('Error searching accounts:', error);
            throw error;
        } finally {
            dispatch(setLoadingSearch(false));
        }
    }
);